import { Heading, Text, TextProps } from '@instabox/consumer-web-ui'
import Link from 'next/link'
import { FC } from 'react'
import ReactMarkdown from 'react-markdown'

import styles from './markdown.module.scss'

export interface MarkdownProps extends TextProps {
  children: string
}

export const Markdown: FC<MarkdownProps> = ({ children, ...textProps }) => {
  return (
    <Text {...textProps} className={styles.markdown} as="div">
      <ReactMarkdown
        linkTarget="_blank"
        components={{
          p: ({ children, ...attributes }) => {
            return (
              <p className={styles.paragraph} {...attributes}>
                {children}
              </p>
            )
          },
          a: ({ children, href }) => {
            if (href?.startsWith('http')) {
              return <a href={href}>{children}</a>
            }
            return <Link href={href || ''}>{children}</Link>
          },
          h3: ({ children, ...attributes }) => {
            return (
              <Heading className="mb-2" fontSize="xs" {...attributes} color="really-red">
                {children}
              </Heading>
            )
          },
          h6: ({ children, ...attributes }) => {
            return (
              <Heading className="mb-2" as="h6" fontSize="sm" {...attributes} color="white">
                {children}
              </Heading>
            )
          },
          ul: ({ children, ...attributes }) => {
            return (
              <ul className={styles.unorderedList} {...attributes}>
                {children}
              </ul>
            )
          },
          ol: ({ children, ...attributes }) => {
            return (
              <ol className={styles.orderedList} {...attributes}>
                {children}
              </ol>
            )
          },
        }}>
        {children}
      </ReactMarkdown>
    </Text>
  )
}

export default Markdown
